<app-banner [banner]="loginPage.banner"></app-banner>
<div id="container" class="container-fluid minHeight">
  <div class="container">
    <form [formGroup]="loginForm" (Submit)="onLoginFormSubmit()">
      <div class="row">
        <div class="col-sm-9 offset-md-3 login-container commonFormsCss">
          <div id="loginbox" class="main-login-box">
            <div class="row">
              <div class="col-md-7">
                <section id="loginForm">
                  <div class="row">
                    <div class="sm-offset-1 col-sm-11">
                      <div class="brd">
                        <div class="row">
                          <div class="col-sm-11 sign-in-heading pt-3 pl-5">
                            <h3>Sign In to your account</h3>
                          </div>
                        </div>
                        <div class="form-group login-form">
                          <div class="row">
                            <div class="col-sm-12 pl-5 pr-5 mb-3">
                              <div
                                class="field-validation-valid text-danger mb-1"
                                *ngIf="submitted && f['eMail'].errors && f['eMail'].errors['required'] && f['password'].errors && f['password'].errors['required']"
                              >
                                Please enter your username or password
                              </div>
                              <span class="control-label">eMail</span><br />

                              <input type="text" formControlName="eMail" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['eMail'].errors && f['password'].value }" />
                              <div class="field-validation-valid text-danger" *ngIf="submitted && f['eMail'].errors && f['password'].value">Please enter your username</div>
                              <div class="field-validation-valid text-danger" *ngIf="submitted && f['eMail'].errors && f['eMail'].errors['email']">Please enter a valid email address</div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-sm-12 pl-5 pr-5">
                              <span class="control-label">Password</span><br />
                              <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f['password'].errors && f['eMail'].value }" />
                              <div *ngIf="submitted && f['password'].errors && f['password'].errors['required'] && f['eMail'].value" class="field-validation-valid text-danger">
                                Please enter your password.
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-sm-12 mt-3 pl-5 pr-5">
                              <div class="checkbox">
                                <input type="checkbox" formControlName="RememberMe" />
                                <label class="remember-me-label" for="RememberMe">Remember me?</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="md-offset-3 col-sm-11">
                      <div>
                        <a href="/account/register">Register a new user</a> |
                        <a href="account/forgot-password">Forgot password</a>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="md-offset-3 col-md-11">
                      <button role="button" type="button" (click)="onLoginFormSubmit()" class="ba-btn btn-thin pull-right">Log in</button>
                    </div>

                    <input type="hidden" id="returnUrl" name="returnUrl" value="/" />
                  </div>
                </section>
              </div>
              <div class="col-md-1"></div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
